import Scene = Phaser.Scene;
import SContainer from "@/cmp/s-container";
import {LevelInfo} from "@/store/artifact/types";
import TextUtils from "@/utils/text-utils";
import ArtifactUtils from "@/utils/artifact-utils";
import {Fonts} from "@/constants/font";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import PricePanel from "@/scenes.ui/price-panel";
import SkillUtils from "@/utils/skill-utils";
import {Tr} from "@/i18n/i18n";

export class ArtLevelLine extends SContainer {

    constructor(scene: Scene, canvas: HTMLCanvasElement, li: LevelInfo, last: boolean = false) {
        super(scene, 0, 0);

        let artEffectText = TextUtils.addTextAdvanced(scene, li.level + ". " + (ArtifactUtils.getEffectText(li.effectType, li.effectValue)!).toUpperCase(),
            -280, 20, '#ffe239', 11, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setOrigin(0, 0.5);

        this.add(artEffectText);

        if (!last) {
            let improveWord = TextUtils.addTextAdvanced(scene, Tr('impr'),
                artEffectText.x / CU.S, artEffectText.y / CU.S + 20, '#ae9d26', 11,
                'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

            let timeIcon = SpriteUtils.addSprite(this.scene, improveWord.getRightCenter().x! / CU.S + 15, improveWord.y / CU.S,
                Keys.ATLAS_PROFILE, Keys.UI_ART_TIME_ICON);
            timeIcon.setDisplaySize(16 * CU.S, 16 * CU.S);

            let timeText = TextUtils.addTextAdvanced(scene, TimeUtils.getDurationText(li.updateSec), timeIcon.getRightCenter().x! / CU.S + 5, timeIcon.y / CU.S,
                '#ae9d26', 11, 'normal', 150, 'left', 2, Fonts.MYRIADPRO_REGULAR).setOrigin(0, 0.5);

            let pricePanel: PricePanel = SpriteUtils.scale(new PricePanel(scene, timeText.getRightCenter().x! + 70 * CU.S, timeText.y + 10, li.updatePrice,
                '#ae9d26', 15, Fonts.MYRIADPRO_REGULAR), 0.7 / CU.S, 0.7 / CU.S);
            pricePanel.setOrigin(0, 0.5);

            let speedupInfo = TextUtils.addTextAdvanced(scene, Tr('spdp') + li.speedupGems,
                timeText.x / CU.S + 125, timeText.y / CU.S, '#727272', 10, 'normal', 150, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            speedupInfo.setOrigin(0, 0.5);

            const gemIcon = SpriteUtils.addImage(this.scene, speedupInfo.getRightCenter().x! / CU.S + 10, speedupInfo.y / CU.S + 1, Keys.IMG_RES_MITHRIL);
            SpriteUtils.setDispSize(gemIcon, 30 * CU.S, 30 * CU.S);

            let braket = TextUtils.addTextAdvanced(scene, '', gemIcon.getRightCenter().x! / CU.S, gemIcon.y / CU.S,
                '#ae9d26', 11, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setOrigin(0, 0.5);

            this.add([improveWord, timeIcon, timeText, pricePanel, speedupInfo, gemIcon, braket]);
        }

        this.height = 55;
    }
}
